import { categories } from "@/mocks/chigua";

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function CategoryIndex() {
  return (
    <section id="category" className="w-full scroll-mt-20 py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <p className="flex items-center gap-2 text-sm font-medium text-primary-600 mb-2">
            <span className="inline-block h-px w-8 bg-primary-400"></span>CATEGORY INDEX
          </p>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950">
            分类索引 · <span className="text-primary-600">按图索骥</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            八大分类把全站内容归拢整齐。顺着你感兴趣的方向点进去，整片瓜田都为你铺好索引。
          </p>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((c) => (
            <li key={c.id}>
              <a
                href="#topic"
                className="group flex h-full flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span
                    className={
                      "flex h-11 w-11 items-center justify-center rounded-lg text-xl " +
                      (toneMap[c.tone] || "bg-secondary-100 text-secondary-700")
                    }
                  >
                    <i className={c.icon}></i>
                  </span>
                  <span className="rounded-full bg-background-100 px-2.5 py-1 text-[11px] text-foreground-500">
                    {c.count} 篇
                  </span>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {c.name}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
                </div>
                <span className="mt-auto inline-flex items-center gap-1 text-sm text-primary-600 font-medium">
                  进入索引
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}